import React, { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Modal } from '../components/ui/Modal';
import { Pagination } from '../components/ui/Pagination';
import { useSearch } from '../hooks/useSearch';
import { useFilters } from '../hooks/useFilters';
import { usePagination } from '../hooks/usePagination';
import { ColumnCustomizer } from '../components/ColumnCustomizer';
import { Textarea } from '../components/ui/Textarea';
import { DatePicker } from '../components/ui/DatePicker';
import { Tooltip } from '../components/ui/Tooltip';
import { Plus, Filter, Download, Eye, Edit, Search, AlertTriangle, Lightbulb, Mail, X, Save, CheckCircle2, Trash2, AlertCircle, Upload, Image as ImageIcon } from 'lucide-react';
import { useNotifications } from '../contexts/NotificationContext';
import { motion, AnimatePresence } from 'framer-motion';
const initialNCData = Array.from({
  length: 50
}, (_, i) => ({
  id: String(i + 1),
  number: `NC-2024/${String(i + 1).padStart(3, '0')}`,
  type: i % 3 === 0 ? 'Non conformità maggiore' : i % 3 === 1 ? 'Non conformità minore' : 'Osservazione',
  origin: i % 3 === 0 ? 'Interna' : i % 3 === 1 ? 'Cliente (reclamo)' : 'Fornitore',
  description: 'Descrizione non conformità...',
  date: '2024-05-10',
  responsible: i % 3 === 0 ? 'Lorenzo' : i % 3 === 1 ? 'Alessio' : 'Gian Franco',
  status: i % 3 === 0 ? 'Aperta' : i % 3 === 1 ? 'Sospesa' : 'Chiusa'
}));
const initialImprovementsData = Array.from({
  length: 20
}, (_, i) => ({
  id: String(i + 1),
  number: `MIG-2024/${String(i + 1).padStart(3, '0')}`,
  subject: `Miglioramento processo ${i + 1}`,
  description: 'Proposta miglioramento processo...',
  date: '2024-05-15',
  status: i % 3 === 0 ? 'In valutazione' : i % 3 === 1 ? 'Sospesa' : 'Approvato',
  responsible: i % 2 === 0 ? 'Alessio' : 'Lorenzo'
}));
const ncColumnsConfig = [{
  key: 'number',
  label: 'Codice'
}, {
  key: 'type',
  label: 'Tipologia'
}, {
  key: 'origin',
  label: 'Origine'
}, {
  key: 'description',
  label: 'Descrizione'
}, {
  key: 'date',
  label: 'Data rilev.'
}, {
  key: 'responsible',
  label: 'Responsabile'
}, {
  key: 'status',
  label: 'Stato'
}, {
  key: 'actions',
  label: 'Azioni'
}];
const impColumnsConfig = [{
  key: 'number',
  label: 'Codice'
}, {
  key: 'subject',
  label: 'Oggetto'
}, {
  key: 'description',
  label: 'Descrizione'
}, {
  key: 'date',
  label: 'Data proposta'
}, {
  key: 'responsible',
  label: 'Responsabile'
}, {
  key: 'status',
  label: 'Stato'
}, {
  key: 'actions',
  label: 'Azioni'
}];
export function NonConformitiesPage() {
  const [activeTab, setActiveTab] = useState<'nc' | 'improvements'>('nc');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [showFilters, setShowFilters] = useState(false);
  // Columns state
  const [visibleColumnsNC, setVisibleColumnsNC] = useState(ncColumnsConfig.map(c => c.key));
  const [visibleColumnsImp, setVisibleColumnsImp] = useState(impColumnsConfig.map(c => c.key));
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [formData, setFormData] = useState<any>({});
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<any>(null);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const {
    addNotification
  } = useNotifications();
  // View modal state
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewItem, setViewItem] = useState<any>(null);
  // NC Hooks
  const {
    filters: filtersNC,
    setFilter: setFilterNC,
    clearFilters: clearFiltersNC,
    filteredData: filterResultNC
  } = useFilters(initialNCData);
  const {
    searchTerm: searchTermNC,
    setSearchTerm: setSearchTermNC,
    filteredData: searchResultNC
  } = useSearch(filterResultNC, ['number', 'description', 'type']);
  const {
    currentPage: currentPageNC,
    totalPages: totalPagesNC,
    paginatedData: paginatedDataNC,
    goToPage: goToPageNC,
    pageSize: pageSizeNC,
    setPageSize: setPageSizeNC,
    totalItems: totalItemsNC,
    setCurrentPage: setCurrentPageNC
  } = usePagination(searchResultNC);
  // Improvements Hooks
  const {
    filters: filtersImp,
    setFilter: setFilterImp,
    clearFilters: clearFiltersImp,
    filteredData: filterResultImp
  } = useFilters(initialImprovementsData);
  const {
    searchTerm: searchTermImp,
    setSearchTerm: setSearchTermImp,
    filteredData: searchResultImp
  } = useSearch(filterResultImp, ['number', 'description', 'subject']);
  const {
    currentPage: currentPageImp,
    totalPages: totalPagesImp,
    paginatedData: paginatedDataImp,
    goToPage: goToPageImp,
    pageSize: pageSizeImp,
    setPageSize: setPageSizeImp,
    totalItems: totalItemsImp,
    setCurrentPage: setCurrentPageImp
  } = usePagination(searchResultImp);
  useEffect(() => {
    setCurrentPageNC(1);
  }, [filtersNC, searchTermNC]);
  useEffect(() => {
    setCurrentPageImp(1);
  }, [filtersImp, searchTermImp]);
  const handleEdit = (item: any) => {
    setSelectedItem(item);
    setFormData(item);
    setIsModalOpen(true);
  };
  const handleView = (item: any) => {
    setViewItem(item);
    setIsViewModalOpen(true);
  };
  const handleViewToEdit = () => {
    setIsViewModalOpen(false);
    handleEdit(viewItem);
  };
  const handleCreate = () => {
    setSelectedItem(null);
    if (activeTab === 'nc') {
      const nextNumber = `NC-2024/${String(initialNCData.length + 1).padStart(3, '0')}`;
      setFormData({
        number: nextNumber,
        status: 'Aperta'
      });
    } else {
      const nextNumber = `MIG-2024/${String(initialImprovementsData.length + 1).padStart(3, '0')}`;
      setFormData({
        number: nextNumber,
        status: 'In valutazione'
      });
    }
    setIsModalOpen(true);
  };
  const handleDelete = (item: any) => {
    setItemToDelete(item);
    setShowDeleteDialog(true);
  };
  const confirmDelete = () => {
    setDeleteSuccess(true);
    setTimeout(() => {
      setDeleteSuccess(false);
      setShowDeleteDialog(false);
      setItemToDelete(null);
      addNotification('success', 'Eliminato', 'Elemento eliminato con successo');
    }, 1500);
  };
  const handleSave = () => {
    setSaveSuccess(true);
    setTimeout(() => {
      setSaveSuccess(false);
      setIsModalOpen(false);
      addNotification('success', activeTab === 'nc' ? 'Non conformità salvata' : 'Miglioramento salvato', 'I dati sono stati salvati correttamente.');
    }, 1500);
  };
  const handleSendReport = () => {
    addNotification('success', 'Report inviato', 'Il report Non conformità è stato inviato al cliente.');
    setIsReportModalOpen(false);
  };
  const hasActiveFiltersNC = Object.keys(filtersNC).some(k => filtersNC[k]);
  const hasActiveFiltersImp = Object.keys(filtersImp).some(k => filtersImp[k]);
  const showOriginSelect = formData.type === 'Non conformità maggiore' || formData.type === 'Non conformità minore';
  return <Layout data-id="element-4286">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4" data-id="element-4287">
        <div data-id="element-4288">
          <h1 className="text-3xl font-bold text-seform-navy" data-id="element-4289">
            Non conformità e miglioramenti
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-4290">
            Gestione NC, reclami e piani di miglioramento.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-4291">
          <div className="bg-slate-100 p-1 rounded-xl flex items-center" data-id="element-4292">
            <button onClick={() => setActiveTab('nc')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${activeTab === 'nc' ? 'bg-white text-seform-navy shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-4293">
              Non conformità
            </button>
            <button onClick={() => setActiveTab('improvements')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${activeTab === 'improvements' ? 'bg-white text-seform-navy shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-4294">
              Miglioramenti
            </button>
          </div>
          <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-4296" />} data-id="element-4295">
            Esporta
          </Button>
          <Button onClick={handleCreate} startContent={<Plus className="h-4 w-4" data-id="element-4298" />} data-id="element-4297">
            {activeTab === 'nc' ? 'Non conformità' : 'Nuovo miglioramento'}
          </Button>
        </div>
      </div>

      {activeTab === 'nc' ? <>
          <Card className="mb-6" noPadding data-id="element-4299">
            <div className="p-4 flex flex-col gap-4" data-id="element-4300">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-4301">
                <div className="flex-1" data-id="element-4302">
                  <Input placeholder="Cerca non conformità..." startContent={<Search className="h-4 w-4" data-id="element-4304" />} value={searchTermNC} onChange={e => setSearchTermNC(e.target.value)} fullWidth data-id="element-4303" />
                </div>
                <div className="flex gap-2" data-id="element-4305">
                  <Button variant={showFilters ? 'solid' : 'flat'} color="secondary" onClick={() => setShowFilters(!showFilters)} startContent={<Filter className="h-4 w-4" data-id="element-4307" />} data-id="element-4306">
                    Filtri{' '}
                    {hasActiveFiltersNC && <Badge variant="primary" size="sm" className="ml-1" data-id="element-4308">
                        {Object.keys(filtersNC).filter(k => filtersNC[k]).length}
                      </Badge>}
                  </Button>
                  <ColumnCustomizer columns={ncColumnsConfig} visibleColumns={visibleColumnsNC} onColumnChange={setVisibleColumnsNC} pageKey="nc" lockedColumns={['number']} data-id="element-4309" />
                </div>
              </div>

              {showFilters && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-4310">
                  <Select label="Stato" value={filtersNC.status || ''} onChange={e => setFilterNC('status', e.target.value)} options={[{
              value: '',
              label: 'Tutti'
            }, {
              value: 'Aperta',
              label: 'Aperta'
            }, {
              value: 'Sospesa',
              label: 'Sospesa'
            }, {
              value: 'Chiusa',
              label: 'Chiusa'
            }]} data-id="element-4311" />
                  <Select label="Tipologia" value={filtersNC.type || ''} onChange={e => setFilterNC('type', e.target.value)} options={[{
              value: '',
              label: 'Tutte'
            }, {
              value: 'Non conformità maggiore',
              label: 'Non conformità maggiore'
            }, {
              value: 'Non conformità minore',
              label: 'Non conformità minore'
            }, {
              value: 'Osservazione',
              label: 'Osservazione'
            }]} data-id="element-4312" />
                  <div className="col-span-full flex justify-end" data-id="element-4313">
                    <Button variant="flat" color="danger" size="sm" onClick={clearFiltersNC} startContent={<X className="h-4 w-4" data-id="element-4315" />} data-id="element-4314">
                      Resetta filtri
                    </Button>
                  </div>
                </div>}
            </div>
          </Card>

          <Card noPadding className="overflow-hidden" data-id="element-4316">
            <div className="overflow-x-auto" data-id="element-4317">
              <table className="w-full text-left border-collapse table-auto" data-id="element-4318">
                <thead data-id="element-4319">
                  <tr className="bg-slate-50/50 border-b border-slate-100 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-4320">
                    {ncColumnsConfig.filter(c => visibleColumnsNC.includes(c.key)).map(col => <th key={col.key} className={`px-4 py-4 ${col.key === 'actions' ? 'text-left pr-6' : ''}`} data-id="element-4321">
                          {col.label}
                        </th>)}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-4322">
                  {paginatedDataNC.map(item => <tr key={item.id} className="hover:bg-slate-50/80 transition-colors group" data-id="element-4323">
                      {visibleColumnsNC.includes('number') && <td className="px-4 py-4 font-mono text-xs text-slate-500" data-id="element-4324">
                          {item.number}
                        </td>}
                      {visibleColumnsNC.includes('type') && <td className="px-4 py-4" data-id="element-4325">
                          <Badge variant={item.type === 'Non conformità maggiore' ? 'danger' : item.type === 'Non conformità minore' ? 'warning' : 'info'} data-id="element-4326">
                            {item.type}
                          </Badge>
                        </td>}
                      {visibleColumnsNC.includes('origin') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-4327">
                          {item.origin || '-'}
                        </td>}
                      {visibleColumnsNC.includes('description') && <td className="px-4 py-4 text-sm text-slate-600 max-w-xs truncate" data-id="element-4328">
                          {item.description}
                        </td>}
                      {visibleColumnsNC.includes('date') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-4329">
                          {item.date}
                        </td>}
                      {visibleColumnsNC.includes('responsible') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-4330">
                          {item.responsible}
                        </td>}
                      {visibleColumnsNC.includes('status') && <td className="px-4 py-4" data-id="element-4331">
                          <Badge variant={item.status === 'Aperta' ? 'danger' : item.status === 'Sospesa' ? 'warning' : 'success'} data-id="element-4332">
                            {item.status}
                          </Badge>
                        </td>}
                      {visibleColumnsNC.includes('actions') && <td className="px-4 py-4 pr-6" data-id="element-4333">
                          <div className="flex items-center gap-1" data-id="element-4334">
                            <Tooltip content="Visualizza NC" data-id="element-4335">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleView(item)} data-id="element-4336">
                                <Eye className="h-4 w-4 text-slate-500" data-id="element-4337" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Invia report" data-id="element-4338">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => setIsReportModalOpen(true)} data-id="element-4339">
                                <Mail className="h-4 w-4 text-blue-500" data-id="element-4340" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Modifica NC" data-id="element-4341">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleEdit(item)} data-id="element-4342">
                                <Edit className="h-4 w-4 text-seform-orange" data-id="element-4343" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Elimina NC" data-id="element-4344">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleDelete(item)} data-id="element-4345">
                                <Trash2 className="h-4 w-4 text-red-500" data-id="element-4346" />
                              </Button>
                            </Tooltip>
                          </div>
                        </td>}
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="border-t border-slate-100" data-id="element-4347">
              <Pagination currentPage={currentPageNC} totalPages={totalPagesNC} onPageChange={goToPageNC} totalItems={totalItemsNC} pageSize={pageSizeNC} onPageSizeChange={setPageSizeNC} data-id="element-4348" />
            </div>
          </Card>
        </> : <>
          <Card className="mb-6" noPadding data-id="element-4349">
            <div className="p-4 flex flex-col gap-4" data-id="element-4350">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-4351">
                <div className="flex-1" data-id="element-4352">
                  <Input placeholder="Cerca miglioramenti..." startContent={<Search className="h-4 w-4" data-id="element-4354" />} value={searchTermImp} onChange={e => setSearchTermImp(e.target.value)} fullWidth data-id="element-4353" />
                </div>
                <div className="flex gap-2" data-id="element-4355">
                  <Button variant={showFilters ? 'solid' : 'flat'} color="secondary" onClick={() => setShowFilters(!showFilters)} startContent={<Filter className="h-4 w-4" data-id="element-4357" />} data-id="element-4356">
                    Filtri{' '}
                    {hasActiveFiltersImp && <Badge variant="primary" size="sm" className="ml-1" data-id="element-4358">
                        {Object.keys(filtersImp).filter(k => filtersImp[k]).length}
                      </Badge>}
                  </Button>
                  <ColumnCustomizer columns={impColumnsConfig} visibleColumns={visibleColumnsImp} onColumnChange={setVisibleColumnsImp} pageKey="improvements" lockedColumns={['number']} data-id="element-4359" />
                </div>
              </div>

              {showFilters && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-4360">
                  <Select label="Stato" value={filtersImp.status || ''} onChange={e => setFilterImp('status', e.target.value)} options={[{
              value: '',
              label: 'Tutti'
            }, {
              value: 'In valutazione',
              label: 'In valutazione'
            }, {
              value: 'Sospesa',
              label: 'Sospesa'
            }, {
              value: 'Approvato',
              label: 'Approvato'
            }, {
              value: 'Scartata',
              label: 'Scartata'
            }]} data-id="element-4361" />
                  <div className="col-span-full flex justify-end" data-id="element-4362">
                    <Button variant="flat" color="danger" size="sm" onClick={clearFiltersImp} startContent={<X className="h-4 w-4" data-id="element-4364" />} data-id="element-4363">
                      Resetta filtri
                    </Button>
                  </div>
                </div>}
            </div>
          </Card>

          <Card noPadding className="overflow-hidden" data-id="element-4365">
            <div className="overflow-x-auto" data-id="element-4366">
              <table className="w-full text-left border-collapse table-auto" data-id="element-4367">
                <thead data-id="element-4368">
                  <tr className="bg-slate-50/50 border-b border-slate-100 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-4369">
                    {impColumnsConfig.filter(c => visibleColumnsImp.includes(c.key)).map(col => <th key={col.key} className={`px-4 py-4 ${col.key === 'actions' ? 'text-left pr-6' : ''}`} data-id="element-4370">
                          {col.label}
                        </th>)}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-4371">
                  {paginatedDataImp.map(item => <tr key={item.id} className="hover:bg-slate-50/80 transition-colors group" data-id="element-4372">
                      {visibleColumnsImp.includes('number') && <td className="px-4 py-4 font-mono text-xs text-slate-500" data-id="element-4373">
                          {item.number}
                        </td>}
                      {visibleColumnsImp.includes('subject') && <td className="px-4 py-4 text-sm font-medium text-slate-900" data-id="element-4374">
                          {item.subject}
                        </td>}
                      {visibleColumnsImp.includes('description') && <td className="px-4 py-4 text-sm text-slate-600 max-w-xs truncate" data-id="element-4375">
                          {item.description}
                        </td>}
                      {visibleColumnsImp.includes('date') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-4376">
                          {item.date}
                        </td>}
                      {visibleColumnsImp.includes('responsible') && <td className="px-4 py-4 text-sm text-slate-600" data-id="element-4377">
                          {item.responsible}
                        </td>}
                      {visibleColumnsImp.includes('status') && <td className="px-4 py-4" data-id="element-4378">
                          <Badge variant={item.status === 'Sospesa' ? 'warning' : 'info'} data-id="element-4379">
                            {item.status}
                          </Badge>
                        </td>}
                      {visibleColumnsImp.includes('actions') && <td className="px-4 py-4 pr-6" data-id="element-4380">
                          <div className="flex items-center gap-1" data-id="element-4381">
                            <Tooltip content="Visualizza miglioramento" data-id="element-4382">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleView(item)} data-id="element-4383">
                                <Eye className="h-4 w-4 text-slate-500" data-id="element-4384" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Modifica miglioramento" data-id="element-4385">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleEdit(item)} data-id="element-4386">
                                <Edit className="h-4 w-4 text-seform-orange" data-id="element-4387" />
                              </Button>
                            </Tooltip>
                            <Tooltip content="Elimina miglioramento" data-id="element-4388">
                              <Button variant="light" size="sm" className="!px-1" onClick={() => handleDelete(item)} data-id="element-4389">
                                <Trash2 className="h-4 w-4 text-red-500" data-id="element-4390" />
                              </Button>
                            </Tooltip>
                          </div>
                        </td>}
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="border-t border-slate-100" data-id="element-4391">
              <Pagination currentPage={currentPageImp} totalPages={totalPagesImp} onPageChange={goToPageImp} totalItems={totalItemsImp} pageSize={pageSizeImp} onPageSizeChange={setPageSizeImp} data-id="element-4392" />
            </div>
          </Card>
        </>}

      {/* View/Consultation Modal */}
      <Modal isOpen={isViewModalOpen} onClose={() => setIsViewModalOpen(false)} title={viewItem ? activeTab === 'nc' ? `Dettaglio non conformità — ${viewItem.number}` : `Dettaglio miglioramento — ${viewItem.number}` : ''} size="2xl" data-id="element-4393">
        {viewItem && activeTab === 'nc' && <div className="space-y-8" data-id="element-4394">
            <section data-id="element-4395">
              <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-4396">
                <AlertTriangle className="h-4 w-4" data-id="element-4397" /> Dettagli non conformità
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4398">
                <div data-id="element-4399">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4400">
                    Codice
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-4401">
                    {viewItem.number}
                  </p>
                </div>
                <div data-id="element-4402">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4403">
                    Tipologia
                  </label>
                  <Badge variant={viewItem.type === 'Non conformità maggiore' ? 'danger' : viewItem.type === 'Non conformità minore' ? 'warning' : 'info'} data-id="element-4404">
                    {viewItem.type}
                  </Badge>
                </div>
                {(viewItem.type === 'Non conformità maggiore' || viewItem.type === 'Non conformità minore') && <div data-id="element-4405">
                    <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4406">
                      Origine
                    </label>
                    <p className="text-sm font-medium text-slate-900" data-id="element-4407">
                      {viewItem.origin || '-'}
                    </p>
                  </div>}
                <div data-id="element-4408">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4409">
                    Data rilevazione
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-4410">
                    {viewItem.date || '-'}
                  </p>
                </div>
                <div data-id="element-4411">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4412">
                    Responsabile
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-4413">
                    {viewItem.responsible || '-'}
                  </p>
                </div>
                <div data-id="element-4414">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4415">
                    Stato
                  </label>
                  <Badge variant={viewItem.status === 'Aperta' ? 'danger' : viewItem.status === 'Sospesa' ? 'warning' : 'success'} data-id="element-4416">
                    {viewItem.status}
                  </Badge>
                </div>
                <div className="col-span-full" data-id="element-4417">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4418">
                    Descrizione
                  </label>
                  <p className="text-sm text-slate-700 bg-slate-50 rounded-lg p-3 border border-slate-100" data-id="element-4419">
                    {viewItem.description || '-'}
                  </p>
                </div>
              </div>
            </section>

            {(viewItem.actionDescription || viewItem.actionResponsible || viewItem.actionDeadline) && <section data-id="element-4420">
                <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-4421">
                  <Lightbulb className="h-4 w-4" data-id="element-4422" /> Azione correttiva
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4423">
                  {viewItem.actionDescription && <div className="col-span-full" data-id="element-4424">
                      <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4425">
                        Descrizione azione
                      </label>
                      <p className="text-sm text-slate-700 bg-slate-50 rounded-lg p-3 border border-slate-100" data-id="element-4426">
                        {viewItem.actionDescription}
                      </p>
                    </div>}
                  {viewItem.actionResponsible && <div data-id="element-4427">
                      <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4428">
                        Responsabile azione
                      </label>
                      <p className="text-sm font-medium text-slate-900" data-id="element-4429">
                        {viewItem.actionResponsible}
                      </p>
                    </div>}
                  {viewItem.actionDeadline && <div data-id="element-4430">
                      <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4431">
                        Scadenza azione
                      </label>
                      <p className="text-sm font-medium text-slate-900" data-id="element-4432">
                        {viewItem.actionDeadline}
                      </p>
                    </div>}
                </div>
              </section>}

            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-4433">
              <Button variant="flat" color="default" onClick={() => setIsViewModalOpen(false)} data-id="element-4434">
                Chiudi
              </Button>
              <Button onClick={handleViewToEdit} startContent={<Edit className="h-4 w-4" data-id="element-4436" />} data-id="element-4435">
                Modifica
              </Button>
            </div>
          </div>}

        {viewItem && activeTab === 'improvements' && <div className="space-y-8" data-id="element-4437">
            <section data-id="element-4438">
              <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-4439">
                <Lightbulb className="h-4 w-4" data-id="element-4440" /> Dettagli miglioramento
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4441">
                <div data-id="element-4442">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4443">
                    Codice
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-4444">
                    {viewItem.number}
                  </p>
                </div>
                <div data-id="element-4445">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4446">
                    Data proposta
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-4447">
                    {viewItem.date || '-'}
                  </p>
                </div>
                <div className="col-span-full" data-id="element-4448">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4449">
                    Oggetto
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-4450">
                    {viewItem.subject || '-'}
                  </p>
                </div>
                <div className="col-span-full" data-id="element-4451">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4452">
                    Descrizione
                  </label>
                  <p className="text-sm text-slate-700 bg-slate-50 rounded-lg p-3 border border-slate-100" data-id="element-4453">
                    {viewItem.description || '-'}
                  </p>
                </div>
                <div data-id="element-4454">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4455">
                    Responsabile
                  </label>
                  <p className="text-sm font-medium text-slate-900" data-id="element-4456">
                    {viewItem.responsible || '-'}
                  </p>
                </div>
                <div data-id="element-4457">
                  <label className="block text-xs font-semibold text-slate-400 uppercase mb-1" data-id="element-4458">
                    Stato
                  </label>
                  <Badge variant={viewItem.status === 'Sospesa' ? 'warning' : 'info'} data-id="element-4459">
                    {viewItem.status}
                  </Badge>
                </div>
              </div>
            </section>

            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-4460">
              <Button variant="flat" color="default" onClick={() => setIsViewModalOpen(false)} data-id="element-4461">
                Chiudi
              </Button>
              <Button onClick={handleViewToEdit} startContent={<Edit className="h-4 w-4" data-id="element-4463" />} data-id="element-4462">
                Modifica
              </Button>
            </div>
          </div>}
      </Modal>

      {/* Create/Edit Modal */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={selectedItem ? activeTab === 'nc' ? 'Modifica non conformità' : 'Modifica miglioramento' : activeTab === 'nc' ? 'Nuova non conformità' : 'Nuovo miglioramento'} size="2xl" data-id="element-4464">
        <AnimatePresence mode="wait" data-id="element-4465">
          {saveSuccess ? <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="flex flex-col items-center justify-center py-16" data-id="element-4466">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 15
          }} className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-4467">
                <CheckCircle2 className="w-12 h-12 text-green-500" data-id="element-4468" />
              </motion.div>
              <p className="text-lg font-semibold text-slate-800" data-id="element-4469">
                {activeTab === 'nc' ? 'Non conformità salvata con successo' : 'Miglioramento salvato con successo'}
              </p>
            </motion.div> : <motion.div key="form" initial={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-4470">
              <div className="space-y-8" data-id="element-4471">
                {activeTab === 'nc' ? <>
                    <section data-id="element-4472">
                      <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-4473">
                        <AlertTriangle className="h-4 w-4" data-id="element-4474" /> Dettagli non
                        conformità
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4475">
                        <Input label="Codice" value={formData.number || ''} onChange={e => setFormData({
                    ...formData,
                    number: e.target.value
                  })} disabled={!!selectedItem} data-id="element-4476" />
                        <Select label="Tipologia" value={formData.type || ''} onChange={e => setFormData({
                    ...formData,
                    type: e.target.value,
                    origin: ''
                  })} options={[{
                    value: 'Non conformità maggiore',
                    label: 'Non conformità maggiore'
                  }, {
                    value: 'Non conformità minore',
                    label: 'Non conformità minore'
                  }, {
                    value: 'Osservazione',
                    label: 'Osservazione'
                  }]} required data-id="element-4477" />

                        {showOriginSelect && <div className="col-span-full animate-in fade-in slide-in-from-top-2" data-id="element-4478">
                            <Select label="Origine" value={formData.origin || ''} onChange={e => setFormData({
                      ...formData,
                      origin: e.target.value
                    })} options={[{
                      value: 'Interna',
                      label: 'Interna'
                    }, {
                      value: 'Cliente (reclamo)',
                      label: 'Cliente (reclamo)'
                    }, {
                      value: 'Fornitore',
                      label: 'Fornitore'
                    }, {
                      value: 'Altro',
                      label: 'Altro'
                    }]} required data-id="element-4479" />
                          </div>}

                        <DatePicker label="Data rilevazione" value={formData.date || ''} onChange={e => setFormData({
                    ...formData,
                    date: e.target.value
                  })} data-id="element-4480" />
                        <Input label="Responsabile" value={formData.responsible || ''} onChange={e => setFormData({
                    ...formData,
                    responsible: e.target.value
                  })} data-id="element-4481" />
                        <div className="col-span-full" data-id="element-4482">
                          <Textarea label="Descrizione non conformità / Osservazione" value={formData.description || ''} onChange={e => setFormData({
                      ...formData,
                      description: e.target.value
                    })} required data-id="element-4483" />
                        </div>

                        <div className="col-span-full" data-id="element-4484">
                          <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-4485">
                            Allegati
                          </label>
                          <div className="border-2 border-dashed border-slate-300 rounded-xl p-6 text-center hover:bg-slate-50 cursor-pointer transition-colors group" data-id="element-4486">
                            <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-white transition-colors" data-id="element-4487">
                              <Upload className="h-6 w-6 text-slate-400 group-hover:text-seform-orange" data-id="element-4488" />
                            </div>
                            <p className="text-sm text-slate-600 font-medium" data-id="element-4489">
                              Clicca per caricare o trascina qui
                            </p>
                            <p className="text-xs text-slate-400 mt-1" data-id="element-4490">
                              JPG, PNG, PDF fino a 10MB
                            </p>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section data-id="element-4491">
                      <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-4492">
                        <Lightbulb className="h-4 w-4" data-id="element-4493" /> Azione correttiva
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4494">
                        <div className="col-span-full" data-id="element-4495">
                          <Textarea label="Descrizione azione" value={formData.actionDescription || ''} onChange={e => setFormData({
                      ...formData,
                      actionDescription: e.target.value
                    })} data-id="element-4496" />
                        </div>
                        <Input label="Responsabile azione" value={formData.actionResponsible || ''} onChange={e => setFormData({
                    ...formData,
                    actionResponsible: e.target.value
                  })} data-id="element-4497" />
                        <DatePicker label="Scadenza azione" value={formData.actionDeadline || ''} onChange={e => setFormData({
                    ...formData,
                    actionDeadline: e.target.value
                  })} data-id="element-4498" />
                        <Select label="Stato" value={formData.status || 'Aperta'} onChange={e => setFormData({
                    ...formData,
                    status: e.target.value
                  })} options={[{
                    value: 'Aperta',
                    label: 'Aperta'
                  }, {
                    value: 'Sospesa',
                    label: 'Sospesa'
                  }, {
                    value: 'Chiusa',
                    label: 'Chiusa'
                  }]} required data-id="element-4499" />
                      </div>
                    </section>
                  </> : <section data-id="element-4500">
                    <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-4501">
                      <Lightbulb className="h-4 w-4" data-id="element-4502" /> Dettagli miglioramento
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4503">
                      <Input label="Codice" value={formData.number || ''} onChange={e => setFormData({
                  ...formData,
                  number: e.target.value
                })} disabled={!!selectedItem} data-id="element-4504" />
                      <DatePicker label="Data proposta" value={formData.date || ''} onChange={e => setFormData({
                  ...formData,
                  date: e.target.value
                })} data-id="element-4505" />
                      <div className="col-span-full" data-id="element-4506">
                        <Input label="Oggetto" value={formData.subject || ''} onChange={e => setFormData({
                    ...formData,
                    subject: e.target.value
                  })} required data-id="element-4507" />
                      </div>
                      <div className="col-span-full" data-id="element-4508">
                        <Textarea label="Descrizione" value={formData.description || ''} onChange={e => setFormData({
                    ...formData,
                    description: e.target.value
                  })} required data-id="element-4509" />
                      </div>
                      <Input label="Responsabile" value={formData.responsible || ''} onChange={e => setFormData({
                  ...formData,
                  responsible: e.target.value
                })} data-id="element-4510" />
                      <Select label="Stato" value={formData.status || 'In valutazione'} onChange={e => setFormData({
                  ...formData,
                  status: e.target.value
                })} options={[{
                  value: 'In valutazione',
                  label: 'In valutazione'
                }, {
                  value: 'Sospesa',
                  label: 'Sospesa'
                }, {
                  value: 'Aperta',
                  label: 'Aperta'
                }, {
                  value: 'Chiusa',
                  label: 'Chiusa'
                }, {
                  value: 'Scartata',
                  label: 'Scartata'
                }]} required data-id="element-4511" />
                    </div>
                  </section>}

                <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-4512">
                  <Button variant="flat" color="default" onClick={() => setIsModalOpen(false)} data-id="element-4513">
                    Annulla
                  </Button>
                  <Button onClick={handleSave} startContent={<Save className="h-4 w-4" data-id="element-4515" />} data-id="element-4514">
                    Salva
                  </Button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </Modal>

      {/* Report Modal */}
      <Modal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} title="Invio report Non conformità" size="md" data-id="element-4516">
        <div className="space-y-6" data-id="element-4517">
          <p className="text-sm text-slate-600" data-id="element-4518">
            Stai per inviare il report della non conformità al cliente via
            email.
          </p>
          <Input label="Email destinatario" defaultValue="cliente@email.it" data-id="element-4519" />
          <Input label="Oggetto" defaultValue="Report Non Conformità #NC-2024/001" data-id="element-4520" />
          <Textarea label="Messaggio" defaultValue="Gentile Cliente, in allegato il report della NC rilevata." data-id="element-4521" />

          <div className="bg-slate-50 p-3 rounded border border-slate-200 flex items-center gap-2 text-sm text-slate-600" data-id="element-4522">
            <Download className="h-4 w-4" data-id="element-4523" /> report_nc_001.pdf
          </div>

          <div className="flex justify-end gap-3 pt-4" data-id="element-4524">
            <Button variant="flat" color="default" onClick={() => setIsReportModalOpen(false)} data-id="element-4525">
              Annulla
            </Button>
            <Button onClick={handleSendReport} startContent={<Mail className="h-4 w-4" data-id="element-4527" />} data-id="element-4526">
              Invia report
            </Button>
          </div>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteDialog} onClose={() => setShowDeleteDialog(false)} title="Conferma eliminazione" size="sm" data-id="element-4528">
        <AnimatePresence mode="wait" data-id="element-4529">
          {deleteSuccess ? <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3
        }} className="flex flex-col items-center justify-center py-12" data-id="element-4530">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            stiffness: 150,
            damping: 15,
            delay: 0.1
          }} className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-4531">
                <CheckCircle2 className="w-10 h-10 text-green-500" data-id="element-4532" />
              </motion.div>
              <p className="text-lg font-semibold text-slate-800" data-id="element-4533">
                Eliminato con successo
              </p>
            </motion.div> : <motion.div key="confirm" initial={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-4534">
              <div className="space-y-6" data-id="element-4535">
                <div className="bg-red-50 p-4 rounded-lg border border-red-100 flex gap-3" data-id="element-4536">
                  <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0" data-id="element-4537" />
                  <div data-id="element-4538">
                    <p className="text-sm text-red-700 font-medium" data-id="element-4539">
                      Attenzione: questa azione è irreversibile.
                    </p>
                    <p className="text-sm text-red-600 mt-1" data-id="element-4540">
                      L'elemento <strong data-id="element-4541">{itemToDelete?.number}</strong> verrà
                      eliminato definitivamente.
                    </p>
                  </div>
                </div>
                <div className="flex justify-end gap-3 pt-4" data-id="element-4542">
                  <Button variant="flat" color="default" onClick={() => setShowDeleteDialog(false)} data-id="element-4543">
                    Annulla
                  </Button>
                  <Button color="danger" onClick={confirmDelete} startContent={<Trash2 className="h-4 w-4" data-id="element-4545" />} data-id="element-4544">
                    Elimina
                  </Button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </Modal>
    </Layout>;
}